import to from 'await-to-js'
import buildClient from '@/api/client'
import npsFeedbackCategories from '@/api/nps-feedback-categories.gql'

export default {
  namespaced: true,
  state: {
    npsFeedbackCategories: [],
  },

  mutations: {
    setState(state, payload) {
      for (let key in payload) state[key] = payload[key]
    },
  },

  actions: {
    async fetchData({ commit }) {
      const [error, data] = await to(buildClient().query(npsFeedbackCategories))
      if (error) {
        this.$rollbar.error(error?.message)
      } else {
        commit('setState', data)
      }
    },
  },
}
